import React from 'react';
import './Marquee.css';

const Marquee = () => {
     return (
          <div className="marquee">
               <div className="track">
                    <div className="content">refill rethink reuse refill rethink reuse refill rethink reuse</div>
               </div>
          </div>
     );
};

export default Marquee;